import RelatedEntriesTablePresentation from 'components/RelatedEntriesTable/RelatedEntriesTablePresentation'

export default {
  Presentation: RelatedEntriesTablePresentation,
}
